function showMessage(massage) {
	const tptMess = document.getElementById('tpt-mess');

	if (tptMess.classList.contains('show')) {
		clearTimeout(mesTimeout);
	}

	document.getElementById('tpt-mess__text').innerHTML = massage;

	tptMess.classList.add('tpt-mess__type-error', 'show');

	mesTimeout = setTimeout(() => {
		tptMess.classList.remove('show');
	}, 4000);
}

function showPersonalise() {
	const personalizeButton = document.querySelector('.tee-btn--personalize');

	if (personalizeButton) {
		personalizeButton.click();
	}
}

function activeTriggerPersonaliseButton() {
	const personaliseTrigger = document.querySelector('tpt-personalise-trigger');

	if (!personaliseTrigger) return;

	const fetchUrl = `https://sizechart.pwa-commerce.com/api/shops/check-stock-decal`;
	const shopId = personaliseTrigger.getAttribute('data-shop-id');
	const productId = personaliseTrigger.getAttribute('data-product-id');
	const urlParams = new URLSearchParams(window.location.search);
	const variantId = urlParams.get('variant');

	personaliseTrigger.classList.add('loading');

	const dataPost = [
		'15106136605040',
		'15106136572272',
		'15106136539504',
		{
			productId: productId,
			variantId: variantId,
		},
	];

	console.log('dataPost____', dataPost);

	// fetch(fetchUrl, {
	// 	method: 'POST',
	// 	headers: {
	// 		'Content-Type': 'application/json',
	// 	},
	// 	body: JSON.stringify({
	// 		shopId: shopId,
	// 		productIds: dataPost,
	// 	}),
	// })
	// 	.then((response) => response.json())
	// 	.then((data) => {
	// 		console.log('Success check personalise:', data);

	// 		if (data.showButton) {
	// 			showPersonalise();
	// 		} else {
	// 			const massage = window.personalise.size_oos;
	// 			showMessage(massage);
	// 		}

	// 		personaliseTrigger.classList.remove('loading');
	// 	})
	// 	.catch((error) => {
	// 		console.error('Error:', error);
	// 	});

	fetch(fetchUrl, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			shopId: shopId,
			productIds: dataPost,
		}),
	})
	.then((response) => response.json())
	.then((data) => {
		console.log('Success check personalise:', data);

		let massage = '';
		var activePersonalise = true;

		// Ưu tiên check product-main trước
		const mainProductOOS = data.data.some(
			(item) =>
				item.type === 'product-main' &&
				item.stock === 0
		);

		console.log('mainProductOOS:', mainProductOOS);

		if (mainProductOOS) {
			massage = window.personalise.size_oos;
			activePersonalise = false;
		} else {
			// Lấy tất cả product-decal
			const decalProducts = data.data.filter(
				(item) => item.type === 'product-decal'
			);

			// Chỉ lỗi khi tất cả decal đều stock < 100
			const allDecalOOS =
				decalProducts.length > 0 &&
				decalProducts.every(
					(item) => item.stock < 100
				);

			if (allDecalOOS) {
				massage = window.personalise.decal_error;

				activePersonalise = false;
			}
		}

		if (activePersonalise) {
			showPersonalise();
		} else {
			showMessage(massage);
		}

		personaliseTrigger.classList.remove('loading');
	})
	.catch((error) => {
		console.error('Error:', error);
		personaliseTrigger.classList.remove('loading');
	});
}

if (!customElements.get('tpt-personalise-trigger')) {
	customElements.define(
		'tpt-personalise-trigger',
		class TptPersonaliseTrigger extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.showPersonalise.bind(this));
			}

			showPersonalise() {
				var showMes = false;
				var optionSelectNameError = '';
				const options = document.querySelectorAll('.option-selectors .bss-custom-product-form__input');

				options.forEach((option) => {
					const optionSelected = option.querySelectorAll('[type="radio"]:checked');
					if (!optionSelected.length) {
						optionSelectNameError = option.closest('.selector-wrapper').querySelector('label').textContent;

						showMes = true;
						return;
					} else {
						showMes = false;
						return;
					}
				});

				if (showMes) {
					const tptMess = document.getElementById('tpt-mess');

					if (tptMess.classList.contains('show')) {
						clearTimeout(mesTimeout);
					}

					const messText = window.personalise.size_error;
					document.getElementById('tpt-mess__text').innerHTML = messText;

					tptMess.classList.add('tpt-mess__type-error', 'show');

					theme.scrollToDetail();

					mesTimeout = setTimeout(() => {
						tptMess.classList.remove('show');
					}, 4000);

					return false;
				} else {
					activeTriggerPersonaliseButton();
				}
				
			}
		},
	);
}
